// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1HEwe","legacyBtn":"MutateMid_legacyBtn__3s-Xq"};